export default __webpack_public_path__ + "static/media/modeling_documents_title_nl.7ed451be.svg";